import { UserFile, UserTask } from '__generated__/api-types-and-hooks'
import { AppDeleteFile } from 'components/AppKanbanBoard/AppDeleteFile/AppDeleteFile.component'
import { AppBinIcon } from 'components/Common/AppSvgIcons/AppBinIcon'
import { AppFileFormatIcon } from 'components/Common/AppSvgIcons/AppFileFormatIcon'
import { AppFileMediaFormatIcon } from 'components/Common/AppSvgIcons/AppFileMediaFormatIcon'
import React, { useEffect, useState } from 'react'

interface IAppTaskFileCardProps {
  file: UserFile
  task?: UserTask
  onDelete?: () => void
  isDeletable?: boolean
  refetch?: () => void
  success?: boolean
  onDeleteSuccess?: (success: boolean) => void
}

export const AppTaskFileCard = ({
  file,
  onDelete,
  isDeletable,
  task,
  refetch,
  success,
  onDeleteSuccess,
}: IAppTaskFileCardProps) => {
  const [showDeleteFileModal, setShowDeleteFileModal] = useState(false)
  const [fileCategory, setFileCategory] = useState<'document' | 'media'>('document')
  const [fileSizeDisplay, setFileSizeDisplay] = useState<string>('')
  const mediaFileTypes = [
    'mp4',
    'mkv',
    'mp3',
    'wav',
    'avi',
    'mov',
    'wmv',
    'flv',
    'mpeg',
    'm4v',
    'webm',
  ]

  useEffect(() => {
    const fileExtension = file.name?.split('.').pop()
    if (
      fileExtension &&
      mediaFileTypes.some((type) => fileExtension.toLowerCase().includes(type))
    ) {
      setFileCategory('media')
    } else {
      setFileCategory('document')
    }

    if (file.size && Number(file.size) < 1000) {
      setFileSizeDisplay(`${file.size} B`)
    } else if (file.size && Number(file.size) >= 1000 && Number(file.size) < 1_000_000) {
      setFileSizeDisplay(`${Math.round(Number(file.size) / 1000)} KB`)
    } else if (file.size && Number(file.size) >= 1_000_000 && Number(file.size) < 1_000_000_000) {
      setFileSizeDisplay(`${Math.round(Number(file.size) / 1_000_000)} MB`)
    } else if (
      file.size &&
      Number(file.size) >= 1_000_000_000 &&
      Number(file.size) < 1_000_000_000_000
    ) {
      setFileSizeDisplay(`${Math.round(Number(file.size) / 1_000_000_000)} GB`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file])

  return (
    <div className="flex items-center justify-between bg-app-white-100 border border-app-grey-20 rounded-lg p-4 shadow-lg">
      <a
        href={file.url || ''}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-3 w-[90%]"
      >
        <div className="">
          {fileCategory === 'media' ? <AppFileMediaFormatIcon /> : <AppFileFormatIcon />}
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-sm font-normal font-inter">{file.name}</span>
          <span className="text-sm font-normal font-inter text-app-grey-70">{fileSizeDisplay}</span>
        </div>
      </a>
      {isDeletable && (
        <div
          onClick={(event) => {
            event.stopPropagation()
            setShowDeleteFileModal(true)
          }}
          className="cursor-pointer"
        >
          <AppBinIcon />
        </div>
      )}

      {showDeleteFileModal && (
        <AppDeleteFile
          task={task}
          file={file}
          onCancel={() => {
            setShowDeleteFileModal(false)
          }}
          onDelete={(success) => {
            if (success) {
              onDeleteSuccess?.(true)
            } else {
              onDeleteSuccess?.(false)
            }
            setShowDeleteFileModal(false)
          }}
        />
      )}
    </div>
  )
}
